module.exports = __webpack_public_path__ + "img/tertiary_5x3_z16.1e1aec7d.svg";